import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import { RegisterState, IRegisterFormData } from './states'
import LeadgenState from './states'
import _ from 'lodash'
const mutations: MutationTree<LeadgenState> = {
  [mutationType.SEND_REGISTER_FORM](
    state: RegisterState,
    data: boolean,
  ): void {
    state.loginStatus = data
  },
  [mutationType.GET_USER_ID](
    state: RegisterState,
    userId: string,
  ): void {
    state.userId = userId
  },
}

export default mutations
